module.exports = __webpack_public_path__ + "static/media/pg_table_w_samples.0c9de9e4.svg";